<template>
  <div class="project-content">
    <div class="project-wrapper">
      <div class="grid">
        <div class="title">
          <h1>{{ projectData.title }}</h1>
          <h2>{{ projectData.subtitle }}</h2>
          <p>Área: <b>{{ projectData.areaName }}</b></p>
          <p>Serviço: <b>{{ projectData.serviceName }}</b></p>
        </div>
        <div v-html="projectData.description"></div>
      </div>
      <img v-lazy="projectData.banner" :alt="projectData.title" class="banner">
      <div class="images-wrapper">
        <div v-for="(item, index) in projectData.images" :key="index" @click="imageIndex = index">
          <img v-lazy="item.image" :alt="item.title" :title="item.title">
        </div>
      </div>
    </div>
    <gallery :images="images" :index="imageIndex" @close="imageIndex = null"></gallery>
  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  name: 'ProjectContent',
  components: {
    'gallery': VueGallery
  },
  data: function () {
    return {
      project: {},
      imageIndex: null,
      images: []
    }
  },
  props: {
    projectData: Object
  },
  created: function () {
    this.project = this.$props.projectData
  },
  methods: {
    goTo: function (pageUrl) {
      this.$router.push('projeto/' + pageUrl)
    }
  },
  watch: {
    projectData (pdata) {
      this.projectData.images.forEach(i => {
        this.images.push(i.image)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .blueimp-gallery {
    background: rgba(0,0,0,0.75);
  }
  .project-content {
    padding: 0 20px 20px;
    text-align: left;
    @media screen and (max-width: 800px) {
      padding: 0 10px 10px;
    }

    .project-wrapper {
      background-color: #fff;
      color: #000;
      padding: 20px;
      border-radius: 10px;

      @media screen and (max-width: 800px) {
        padding: 10px;
      }

      .banner {
        border-radius: 10px;
        margin-bottom: 30px;

        @media screen and (max-width: 800px) {
          margin-bottom: 10px;
        }
      }

      img {
        max-width: 100%;
        height: auto;
      }

      .grid {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        grid-gap: 20px;
        margin-bottom: 30px;

        @media screen and (max-width: 800px) {
          grid-template-columns: 1fr;
        }
      }

      h1 {
        font-weight: 500;
        text-transform: uppercase;
        margin-top: 12px;
        margin-bottom: 10px;
      }

      h2 {
        margin-top: 0;
        font-weight: 300;
      }

      .title p {
        margin-bottom: 0;
        font-weight: 300;

        b {
          font-weight: 500;
        }
      }
    }

    .images-wrapper {
      -webkit-column-count: 3;
      -moz-column-count: 3;
      column-count: 3;
      -webkit-column-gap: 10px;
      -moz-column-gap: 10px;
      column-gap: 10px;

      img {
        width: 100%;
        height: auto;
        margin: 5px;
        border-radius: 10px;
        display: inline-block;
        -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        cursor: pointer;
        -webkit-transition: all .3s;
        transition: all .3s;
      }
    }
  }
</style>
